import { maxWidth } from "../../../shared/styleconfig";
import { useEffect, useState } from "react";
import Backtest from "./Backtest";
import { algoValidations } from "../../../services/Stock";
import {SavePopup} from './SavePopup'

export const DNDActionButtons = ({
    dndRequest,
    runTestAlgo,
    algoDetails
}) => {
    const [open, setOpen] = useState(false);
    const [openSave, setOpenSave] = useState(false);
    const [algoAction, setAlgoAction] = useState('')
    // const [buyCandle, setBuyCandle] = useState(null);
    // const [sellCandle, setSellCandle] = useState(null);

    const [algoResult, setAlgoResult] = useState([]);
    const [backtestStats, setBacktestStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedStockList, setSelectedStockLst] = useState([]);

    const commonCSS = `flex flex-row gap-[14px] justify-end p-[15px]`
    const bottomButtons = `w-[122px] h-[40px] border border-solid rounded-[11px] border-white text-white opacity-[0.5] hover:opacity-[1] text-xs`

    useEffect(() => {
        if(algoDetails){
            const backtest_details = JSON.parse(algoDetails?.backtest_details);
            setSelectedStockLst(backtest_details?.stocks || []);
        }
    },[algoDetails])

    // const getIndicatorAPI = async (type, period, stock, interval, req) => {
    //     if(req?.rightLogic?.type === "component") {
    //         const indicatorsCollection = [];
    //         indicatorsCollection.push({
    //             "indicator": type,
    //             "period": period,
    //             "interval": interval
    //         })
    //         const payload = {
    //             "secret": TAAPI_API_KEY,
    //             "construct": {
    //                 "type": "stocks",
    //                 "symbol": stock,
    //                 "interval": interval,
    //                 "addResultTimestamp":true,
    //                 "indicators": indicatorsCollection
    //             }
    //         }
    //         const uri = `https://api.taapi.io/bulk`
    //         return axios.post(uri, payload)
    //     }
    //     else {
    //         return req?.rightLogic?.value
    //     }
    // }

    // const getLeftIndicatorAPI = async (reqData) => {
    //     const queryData = await Promise.all(reqData?.map((item, index) => {
    //         const period = item?.leftLogic?.timeRange;
    //         const interval = '1d';
    //         const stockQuanity = item?.shares;
    //         const operator = item?.operationType
    //         const stock = item?.stock?.symbol
    //         const indicatorType = item?.leftLogic?.componentName?.toLowerCase()
    //         const hasRightIndicator = item?.rightLogic?.type === 'component'
    //         const indicatorTypeRight = item?.rightLogic?.componentName?.toLowerCase()
            
    //         const indicatorsCollection = [];
    //         indicatorsCollection.push({
    //             "indicator": "candle",
    //             "backtracks": 10
    //         })
    //         indicatorsCollection.push({
    //             "indicator": indicatorType,
    //             "period": period,
    //             "backtracks": 10,
    //             "interval": item?.leftLogic?.interval,
    //         })

    //         const payload = {
    //             "secret": TAAPI_API_KEY,
    //             "construct": {
    //                 "type": "stocks",
    //                 "symbol": stock,
    //                 "interval": interval,
    //                 "addResultTimestamp":true,
    //                 "indicators": indicatorsCollection
    //             }
    //         }

    //         const uri = `https://api.taapi.io/bulk`
    //         return axios.post(uri, payload)
    //     }))
    //     return queryData
    // }

    // const setCandleData = (reqData, req, rsiValue, setCandle, buyCandles) => {
    //     let breakpointIndex = null
        
    //     let buyPointType= null
    //     let buyQty = 0
    //     reqData?.reverse().forEach((item, index)=>{
    //         const result = item?.result;
    //         const value = result?.value;
    //         const stockQuanity = req[0]?.shares;
    //         const operator = req[0]?.operationType
    //         buyPointType = req[0]?.leftLogic?.status
    //         buyQty = req[0]?.shares
    //         if(breakpointIndex !== null){
    //             return  
    //         }
    //         let finalRSIValue = ''
    //         if(req[0]?.rightLogic?.type === 'component') {
    //             finalRSIValue = rsiValue?.data?.data[0]?.result?.value;
    //         }
    //         else {
    //             finalRSIValue = rsiValue
    //         }
    //         if (operator === '<' && value < finalRSIValue) {
    //             breakpointIndex = index
    //         } else if(operator === '>' && value > finalRSIValue){
    //             breakpointIndex = index
    //         } else if(operator === '=' && value === finalRSIValue){
    //             breakpointIndex = index
    //         } else if(operator === 'and' && (value && finalRSIValue)){
    //             breakpointIndex = index
    //         } else if(operator === 'or' && (value || finalRSIValue)){
    //             breakpointIndex = index
    //         } 
    //     })

    //     return breakpointIndex
       
        
    // }

    const runBackTest = async () => {
        const isValidAlgo = algoValidations(dndRequest);
        if(isValidAlgo){
            setOpen(true)
        }
        // loadingToaster("Please Wait algo is running.")
        /*
        const buyObj = {};
        setBuyCandle(null)
        setSellCandle(null)
        const buyReq = dndRequest?.filter((item) => item?.type === 'BUY')
        const sellReq = dndRequest?.filter((item) => item?.type === 'SELL')

        if(!buyReq?.length || !sellReq?.length){
            errorToaster("Please create algo before running")
            return 
        }

        let operationType = false;
        let isBuyActive = false;
        let isSellActive = false;
        if(buyReq?.length || sellReq?.length){
            if(buyReq?.length && buyReq[0]?.operationType){
                operationType = true
                isBuyActive = true
            }
            if (sellReq?.length && sellReq[0]?.operationType){
                operationType = true
                isSellActive = true
            }
        }

        // operator check
        if (!operationType) return errorToaster('Please create algo before starts testing')

        //Buy Start
        if(isBuyActive){
            const buyIndicatorType = buyReq[0]?.leftLogic?.componentName?.toLowerCase()
            const buyperiod = buyReq[0]?.leftLogic?.timeRange;

            if(buyIndicatorType === '' && buyperiod === 0 ){
                errorToaster('Buy Left Indicator is required.')
                return 
            }
            const buyRightValue = await getIndicatorAPI(
                buyReq[0],
                buyReq[0]?.stock?.symbol,
                buyReq[0]?.rightLogic?.componentName?.toLowerCase(),
                buyReq[0]?.rightLogic?.timeRange,
                buyReq[0]?.rightLogic?.interval
            )
            const buyLeftValues = await getLeftIndicatorAPI(buyReq)
            const buyData = [...buyLeftValues[0]?.data?.data]
            const buyCandles = buyData?.splice(0,10);
            const buyBreakIndex = setCandleData(buyData, buyReq, buyRightValue, setBuyCandle)
            let breakPointcandle = null
            if(buyBreakIndex !== null ){
                breakPointcandle = buyCandles?.reverse()[buyBreakIndex]
            }
            if(breakPointcandle !== null){
                setBuyCandle({...breakPointcandle, buyOn: buyReq[0]?.leftLogic?.status, buyQty: buyReq[0]?.shares});
            }
        }
        //Buy Ends

        //Sell Start
        if(isSellActive){
            const sellIndicatorType = sellReq[0]?.leftLogic?.componentName?.toLowerCase()
            const sellperiod = sellReq[0]?.leftLogic?.timeRange;

            if(sellIndicatorType === '' && sellperiod === 0 ){
                errorToaster('Sell Left Indicator is required.')
                return 
            }
            const sellRightValue = await getIndicatorAPI(
                sellReq[0],
                sellReq[0]?.stock?.symbol,
                sellReq[0]?.rightLogic?.componentName?.toLowerCase(),
                sellReq[0]?.rightLogic?.timeRange,
                sellReq[0]?.rightLogic?.interval
            )
            const sellLeftValues = await getLeftIndicatorAPI(sellReq)
            const sellData = [...sellLeftValues[0]?.data?.data]
            const sellCandles = sellData?.splice(0,10);
           
            const sellBreakIndex = setCandleData(sellData, sellReq, sellRightValue, setSellCandle, sellCandles)
            let sbreakPointcandle = null
            if(sellBreakIndex !== null ){
                sbreakPointcandle = sellCandles?.reverse()[sellBreakIndex]
            }
            if(sbreakPointcandle !== null){
                setSellCandle({...sbreakPointcandle, sellOn: sellReq[0]?.leftLogic?.status, sellQty: sellReq[0]?.shares});
            }
        }
        //Sell Ends
        setOpen(true)
        */
    }

    
    return (
        <>
            <div className={`w-full h-[71px] bg-[#0061FC]`}>
                <div className={`h-full w-full ${maxWidth} mx-auto flex flex-row justify-end`}>
                    <div className={`${commonCSS} border-r border-white`}>
                        <button className={bottomButtons} onClick={() => {
                            const isValidAlgo = algoValidations(dndRequest);
                            if(isValidAlgo){
                                setAlgoAction('Save')
                                setOpenSave(true)
                            }
                        }}>
                            Save
                        </button>
                        <button className={bottomButtons} onClick={runBackTest} >
                            Backtest
                        </button>
                        <button className={bottomButtons} onClick={() => runTestAlgo()}>
                            Run Algo
                        </button>
                    </div>
                    <div className={commonCSS}>
                        <button className={`${bottomButtons} bg-[#001639] w-[170px] border !border-[#001639] `} onClick={() => {
                            const isValidAlgo = algoValidations(dndRequest);
                            if(isValidAlgo){
                                setAlgoAction('Publish')
                                setOpenSave(true)
                            }
                        }}>
                            Publish to Community
                        </button>
                    </div>
                </div>
            </div>

            {
                open ? <Backtest 
                    dndRequest={dndRequest}
                    open={open}
                    handleClose={()=> setOpen(false)}
                    setAlgoResult={setAlgoResult}
                    algoResult={algoResult}
                    backtestStats={backtestStats}
                    setBacktestStats={setBacktestStats}
                    loading={loading}
                    setLoading={setLoading}
                    setSelectedStockLst={setSelectedStockLst}
                    selectedStockList={selectedStockList}
                /> : ""
            }

            {openSave ?
            <SavePopup algoDetails={algoDetails} algoAction={algoAction} dndRequest={dndRequest} showPopup={openSave} handleClose={()=> setOpenSave(false)} setAlgoResult={setAlgoResult}
            algoResult={algoResult}
            backtestStats={backtestStats}
            setBacktestStats={setBacktestStats}
            loading={loading}
            setLoading={setLoading}
            setSelectedStockLst={setSelectedStockLst}
            selectedStockList={selectedStockList}/> : ""}

        </>
    );
};